module.exports = __webpack_public_path__ + "static/img/AIGC设计-KV.a596cfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10009/AIGC设计-KV.png
// module id = 4IG5
// module chunks = 1